export const MONTH_PLACEHOLDER = 'MM'
export const YEAR_PLACEHOLDER = 'YY'

export const normalizePlaceholder =
  (p: string, forward = true) =>
  (value = '') =>
    forward ? `${value}${p.slice(value.length)}` : value ? `${p.slice(0, -value.length)}${value}` : p

export const normalizeDate = (value: string, previousValue?: string) => {
  if (!value) {
    return value
  }
  const onlyNums = value.replace(/[^\d]/g, '')
  if (!previousValue || value.length > previousValue.length) {
    if (onlyNums.length === 4) return `${onlyNums}-`
    if (onlyNums.length === 6) return `${onlyNums.slice(0, 4)}-${onlyNums.slice(4)}-`
  }
  if (onlyNums.length <= 4) return onlyNums
  if (onlyNums.length <= 6) return `${onlyNums.slice(0, 4)}-${onlyNums.slice(4)}`
  return `${onlyNums.slice(0, 4)}-${onlyNums.slice(4, 6)}-${onlyNums.slice(6, 8)}`
}

export const normalizeText = (value: string) => value?.trimStart()

export const normalizeToAlphanumeric = (value: string) => value?.replace(/[^0-9a-zA-Z]/g, '')

export const normalizeToNumbers = (value: string) => value?.replace(/\D/g, '')

export const normalizeCardNrPayment = (v: string) => v && (v.replace(/\s|-/g, '').match(/.{1,4}/g) || []).join(' ')

export const normalizeCardNr = (v: string) => v && (v.replace(/-/g, '').match(/.{1,4}/g) || []).join('-')

export const normalizeCardMY = (v: string) => v && (v.replace(/\//g, '').match(/.{1,2}/g) || []).join('/')

export const normalizeGiftCode = (value: string) => {
  return value
    ? value
        .replace(/\s/g, '')
        .match(/.{1,4}/g)
        ?.join(' ')
    : value
}

export const normalizeWithPrefix =
  (p: string, char = '0') =>
  (value = '', _count = p.length - value.length) =>
    value ? `${char.repeat(_count > 0 ? _count : 0)}${value.slice(-p.length)}` : p

export const normalizeMonth = normalizeWithPrefix(MONTH_PLACEHOLDER)
export const normalizeYear = normalizeWithPrefix(YEAR_PLACEHOLDER)
